import HTTP from '../HTTP';
import store from '../../store/store';

const PANNEAUXLC_URL = 'PanneauxLc';
const PANNEAUXLC_TLPE_URL = 'PanneauxLc/calcul-tlpe';

export async function getPanneauxLcTlpe(facNum, annee) {
  try {
    const response = await HTTP.get(PANNEAUXLC_TLPE_URL + '/' + facNum + '/' + annee);
    return response;
  } catch (e) {
    return null;
  }
}

export async function browsePanneaux(location, rayon, dateStart, dateEnd, proposableLc,
  codeFace) {
  const user = store.getters['user/user'];
  const secteursId = user.secteursId;
  let propoLc = '';
  if (proposableLc === '1') {
    propoLc = '&proposableLc=true';
  }
  if (proposableLc === '0') {
    propoLc = '&proposableLc=false';
  }
  if (codeFace === '') {
    try {
      const response = await HTTP.get(PANNEAUXLC_URL + '?latitude=' + location.lat
                                                    + '&longitude=' + location.lng
                                                    + '&rayon=' + rayon
                                                    + '&datedebut=' + dateStart
                                                    + '&datefin=' + dateEnd
                                                    + '&secteurIds=' + secteursId
                                                    + propoLc);
      return response;
    } catch (e) {
      throw e;
    }
  } else {
    try {
      const response = await HTTP.get(PANNEAUXLC_URL + '?latitude=' + location.lat
                                                    + '&longitude=' + location.lng
                                                    + '&rayon=' + rayon
                                                    + '&datedebut=' + dateStart
                                                    + '&datefin=' + dateEnd
                                                    + '&codeFace=' + codeFace
                                                    + '&secteurIds=' + secteursId
                                                    + propoLc);
      return response;
    } catch (e) {
      throw e;
    }
  }
}

export async function other() {
  try {
    const response = await HTTP.get(PANNEAUXLC_URL);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getPanneauxPoints(locations, rayon, dateStart, dateEnd,
  proposableLc, codeFace) {
  try {
    if (!locations.length) {
      return [];
    }
    const requests = [];
    locations.forEach(location => {
      requests.push(browsePanneaux(location.coordonnees, rayon, dateStart,
        dateEnd, proposableLc, codeFace));
    });
    const response = await Promise.all(requests);
    for (let i = 0; i < response.length; i += 1) {
      for (let j = 0; j < response[i].data.length; j += 1) {
        response[i].data.forEach(r => {
          r.pointAddress = locations[i];
        });
      }
    }
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getPlanningPdf(
  location, rayon, dateDebut, dateFin,
  proposableLc, user, panneauFilter) {
  let propoLc = '';
  if (proposableLc === '1') {
    propoLc = 'true';
  }
  if (proposableLc === '0') {
    propoLc = 'false';
  }
  const data = {
    latitude: location.lat,
    longitude: location.lng,
    rayon,
    dateDebut,
    dateFin,
    proposableLc: propoLc,
    user,
    panneauFilter,
  };
  try {
    const response = await HTTP.post(PANNEAUXLC_URL + '/planningPdf', data, { responseType: 'blob' });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function nogeo() {
  try {
    const response = await HTTP.get(PANNEAUXLC_URL + '/no-geo');
    return response;
  } catch (e) {
    throw e;
  }
}

export async function noattachment() {
  try {
    const response = await HTTP.get(PANNEAUXLC_URL + '/no-attachment');
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getProduitFaceLc(id) {
  const response = await HTTP.get(PANNEAUXLC_URL + '/produitFace/' + id);
  return response;
}

export async function getFicheLc(data) {
  const response = await HTTP.post(PANNEAUXLC_URL + '/ficheLc', data, { responseType: 'blob' });
  return response;
}



// WEBPACK FOOTER //
// ./src/api/PanneauxLc/index.js